import { GeneralModel } from "./general.model";
import { WeightGroup } from "./weightGroup.model";
import {Formula} from "./formula.model";


export class Weight extends GeneralModel {
    weightGroupId: number;
    weightGroup: WeightGroup;
    formulaId: number;
    formula: Formula;
    weightFrom: number;
    weightTo: number;
    weightPlus: number;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/weight.model.ts